/**
 * Ensures a string representation of a number has two digits.
 * e.g. "3" => "03", "12" => "12"
 * @private
 * @param t - The time value to format as a string or number
 * @returns The formatted string with two digits
 */
const forceTwoDigits = (t: string | number): string => `0${t}`.slice(-2);

/**
 * Formats a duration in hours and minutes into a human-readable string.
 * @function
 * @param hours - The number of hours
 * @param minutes - The number of minutes (optional, defaults to 0)
 * @returns The formatted duration (e.g., "02:30")
 */
const formatDuration = (
    hours: string | number,
    minutes?: string | number
): string => {
    return `${forceTwoDigits(hours)}:${forceTwoDigits(minutes || 0)}`;
};

export default formatDuration;
